/*
 * バリデーション（パスワード設定関連）
 */
import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequiredText, strMax, strMin, isValidFormatPassword, isConfirm, } from '@/utils/validate/conditions';
/**
 * validation: パスワード設定
 */
export const validatePasswordInput = composeValidators(isRequiredText('パスワードを入力してください'), strMax(50, 'パスワードは50文字以内で入力してください'), strMin(8, 'パスワードは8桁以上で入力してください'), isValidFormatPassword('パスワードには半角英字、半角数字、半角記号を少なくともそれぞれ1文字ずつ含めてください。また、先頭・末尾にスペースは使用できません'));
/**
 * validation: パスワード設定（確認用）
 */
export const validatePasswordConfirm = composeValidators(isRequiredText('パスワード（確認用）を入力してください'), isConfirm('パスワードと同じ値を入力してください', 'password'));
